import type { ComponentType } from "react";
import BillingInfoComponent from "./BillingInfo.jsx";

const BillingInfo = BillingInfoComponent as ComponentType<any>;
export default BillingInfo;
